import clsx from "clsx";
import {
  CustomizedXAxisTick,
  selectFormat,
  StandardTooltip,
} from "components/Utils/Utils";
import React, { PureComponent } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default class HearstTactics extends PureComponent {
  render() {
    const data = this.props.data.data.map((e) => ({
      x: e.video_impressions,
      y: e.video_completion_rate,
      ...e,
    }));

    return (
      <>
        <ResponsiveContainer height={285}>
          <ScatterChart
            height={200}
            margin={{
              top: 20,
              bottom: 20,
            }}
          >
            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />
            <XAxis
              type="number"
              dataKey="x"
              name="Impressions:"
              tickFormatter={(d) => selectFormat("number", d)}
              tick={<CustomizedXAxisTick />}
            />
            <YAxis
              yAxisId="left"
              type="number"
              dataKey="y"
              name="Completion Rate:"
              tickFormatter={(d) => selectFormat("percentage", d)}
              mirror
            />
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;
                      return (
                        <div className="standard-tooltip">
                          <header className="standard-tooltip__header">
                            <span className="standard-tooltip__key-header">
                              Tactic Name:
                            </span>
                            <span className="standard-tooltip__value-header">
                              {tooltip_data.tactic_name}
                            </span>
                          </header>
                          <main className="standard-tooltip__main">
                            {Object.keys(payload)
                              .sort(
                                (a, b) => payload[b].value - payload[a].value
                              )
                              .map((key) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={key}
                                >
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background: "#fc6d52",
                                    }}
                                  />
                                  <span
                                    className={clsx(
                                      "standard-tooltip__key",
                                      "text-capitalize"
                                    )}
                                    style={{ color: payload[key].color }}
                                  >
                                    {payload[key].name}
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {payload[key].dataKey === "x"
                                      ? selectFormat(
                                          "number",
                                          payload[key].value
                                        )
                                      : selectFormat(
                                          "percentage",
                                          payload[key].value
                                        )}
                                  </span>
                                </div>
                              ))}
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />
            <Scatter yAxisId="left" data={data} fill="#fc6d52" />
          </ScatterChart>
        </ResponsiveContainer>
      </>
    );
  }
}
